/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface SnippetErrorsObject {
  name?: string[];
  value?: string[];
}

interface SnippetErrorsArgs {
  showErrors: boolean;
  errors?: SnippetErrorsObject;
}

export default class SnippetErrors extends Component<SnippetErrorsArgs> {
  get errors() {
    if (!this.args.errors) {
      return;
    }

    return Object.entries(this.args.errors).map(([attribute, errors]) => {
      return { attribute, errors };
    });
  }
}
